import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const useScrollToAnchor = () => {
  const location = useLocation();

  useEffect(() => {
    const scrollTarget = location.state?.scrollTo || location.hash?.slice(1);
    if (scrollTarget) {
      setTimeout(() => {
        const element = document.getElementById(scrollTarget);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }, 100);

      if (location.state?.scrollTo) {
        window.history.replaceState({}, document.title);
      }
    }
  }, [location]);
};
